/** @deprecated Scroll is handled by Layout.tsx — kept for backwards compatibility. */
export const dashboardPage = '';

/** @deprecated Scroll is handled by Layout.tsx — kept for backwards compatibility. */
export const scrollPage = '';

/** Demo/test artifact filter toggle — active (artifacts hidden). */
export const artifactFilterBtnActive =
    'bg-amber-600 text-white border border-amber-700/80 hover:bg-amber-700 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/35 dark:hover:bg-amber-500/25';

/** Demo/test artifact filter toggle — idle (showing all cases). */
export const artifactFilterBtnIdle =
    'bg-secondary/60 text-secondary-foreground border border-border hover:bg-secondary';

export const dashboardPanel =
    'bg-card border border-border rounded-xl';

export const dashboardPanelFeatured =
    `${dashboardPanel} border-t-4 border-t-primary`;

export const dashboardPanelHover =
    'hover:border-primary/40 hover:bg-muted transition-colors';

export const dashboardStatCard =
    `${dashboardPanel} p-4 ${dashboardPanelHover} cursor-default`;

export const dashboardStatCardInteractive =
    `${dashboardPanel} p-4 ${dashboardPanelHover} cursor-pointer`;

export const dashboardSectionTitle = 'text-lg font-semibold tracking-tight text-foreground';

export const dashboardHeroSearch =
    'pl-9 pr-3 py-2 border border-input rounded-lg bg-card text-sm w-64 focus:ring-2 focus:ring-primary/40 focus:border-transparent transition-colors';

export const dashboardPrimaryBtn =
    'px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors';

export const dashboardFilterChipActive =
    'bg-primary text-primary-foreground';

export const dashboardFilterChipInactive =
    'bg-secondary/50 text-muted-foreground hover:bg-secondary hover:text-foreground';

/** Sticky section jump-nav bar on the Dashboard. */
export const dashboardSectionNavBar =
    'bg-background border-b border-border';

/** Offset so sticky section nav does not cover section headings. */
export const dashboardSectionScrollMt = 'scroll-mt-20';

/** Theme-safe status badges (replace light-only bg-green-100 etc.) */
export function statusBadgeClass(status: string): string {
    const base = 'px-2 py-0.5 rounded-full text-xs font-medium';
    switch (status?.toUpperCase()) {
        case 'OPEN':
        case 'COMPLETED':
            return `${base} bg-emerald-500/15 text-emerald-600 dark:text-emerald-400`;
        case 'PROCESSING':
            return `${base} bg-amber-500/15 text-amber-600 dark:text-amber-400`;
        case 'CLOSED':
            return `${base} bg-secondary text-muted-foreground`;
        case 'ARCHIVED':
            return `${base} bg-yellow-500/15 text-yellow-700 dark:text-yellow-400`;
        default:
            return `${base} bg-secondary text-muted-foreground`;
    }
}

export function importJobBadgeClass(status: string): string {
    const base = 'inline-flex px-2 py-0.5 rounded-full text-[10px] font-medium';
    switch (status) {
        case 'completed':
            return `${base} bg-emerald-500/15 text-emerald-600 dark:text-emerald-400`;
        case 'processing':
            return `${base} bg-amber-500/15 text-amber-600 dark:text-amber-400`;
        default:
            return `${base} bg-secondary text-muted-foreground`;
    }
}
